module.exports = __webpack_public_path__ + "static/remove_access_form-331b07747fe4fb74b2d127943465208c.png";